import React from 'react';
/** import third-party libraries in the section above, keep the ascending order */

import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
/** import mui components in the section above, keep the ascending order */

/** import widgets components in the section above, keep the ascending order */

import { DealCategory } from 'common/constants/deals';
/** import classes and others in the section above, keep the ascending order */

const getMessage = ({ deal, userIsInternal }) => {
    if (deal?.category === DealCategory.Private || deal?.category === DealCategory.Guaranteed) {
        if (!deal?.ads?.length) {
            return `No active ads for this ${
                deal.category
            } deal at the moment. This deal category is restricted to your organization.`;
        }

        return `You are currently viewing active ads related to this ${
            deal.category
        } deal, restricted to your organization. Click on the link column to access the campaign.`;
    }

    if (!deal?.ads?.length) {
        if (userIsInternal) {
            return 'No active ads for this deal at the moment for all organizations.';
        }

        return 'No active ads for this deal at the moment for your organization.';
    }

    if (userIsInternal) {
        return 'You are currently viewing active ads related to this deal for all organizations. Click on the link column to access the campaign.';
    }

    return 'You are currently viewing active ads related to this deal for your organization. Click on the link column to access the campaign.';
};

const InfoAlertDealAdsDisclaimer = ({ deal, userIsInternal }) => {
    return (
        <Box sx={{ marginTop: '12px', marginBottom: '12px' }}>
            <Alert severity="info" sx={{ alignItems: 'center', fontSize: '0.95rem' }}>
                {getMessage({ deal, userIsInternal })}
            </Alert>
        </Box>
    );
};

export default InfoAlertDealAdsDisclaimer;
